import { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    q: "Hva er dimensjonene på GEILO?",
    a: "LYKKE GEILO har ytre mål på 350 × 230 × 280 cm. Grunnflaten er cirka 12,4 m². Det er en stor badstue designet for 6 personer med to benkenivåer."
  },
  {
    q: "Hvilke materialer brukes i konstruksjonen?",
    a: "GEILO bruker STEICO-isolasjon på vegg, tak og gulv, aluminiumsfolie som dampsperre og Isola Tyvek Pro Safe som vindvern. Innvendig panel er Aspetre STS4, og dørrammen er asp."
  },
  {
    q: "Hvor lang er leveringstiden?",
    a: "Standard leveringstid er 6–8 uker. Tillegg og spesielle konfigurasjoner kan påvirke leveringstiden. Vi anbefaler å kontakte oss for eksakt timeline."
  },
  {
    q: "Kan jeg oppgradere panelene?",
    a: "Ja, du kan velge mellom Aspetre (standard), Termo Asp, Abachi eller Sort Asp STS4 IGNITE. Hver oppgradering har en ekstra kostnad og gir ulike estetiske og funksjonelle fordeler."
  },
  {
    q: "Hvilke ovnalternativer finnes?",
    a: "Standard er HUUM Hive Mini 9 kW. Du kan oppgradere til HUUM Hive Wood 13 kW (vedovn) som gir en mer tradisjonell badstuopplevelse."
  },
  {
    q: "Er det mulig å legge til lys- og lydanlegg?",
    a: "Ja. Du kan velge RGB-lyssterapi for fargeskiftende belysning eller et JBL-lydanlegg med Bluetooth. Standard belysning er varmt LED-lys."
  },
  {
    q: "Hva er inkludert i standardutgaven?",
    a: "Standard levering inkluderer Aspetre panel, HUUM Hive Mini 9 kW ovn, LED-belysning, Aspetre benker med to nivåer, trebygulv og LYKKE löyly pakke (bøtte, øse, termometer, timeglass)."
  },
  {
    q: "Kan jeg velge gulvmateriale?",
    a: "Ja, du kan erstatte trebygulvet med natursteinflis eller porselensfliser. Begge alternativene er holdbare og lette å rengjøre."
  }
];

export default function GeiloFaqAccordion() {
  const [open, setOpen] = useState(null);

  return (
    <div className="space-y-3">
      {faqData.map((item, i) => (
        <button
          key={i}
          onClick={() => setOpen(open === i ? null : i)}
          className="w-full text-left p-5 bg-white border border-border/40 hover:border-border/60 transition-all duration-300"
        >
          <div className="flex items-start justify-between gap-4">
            <h3 className="font-heading text-2xl font-normal text-foreground">{item.q}</h3>
            <ChevronDown
              size={18}
              className={`flex-shrink-0 text-foreground/40 transition-transform duration-300 ${
                open === i ? "rotate-180" : ""
              }`}
            />
          </div>
          {open === i && (
           <p className="text-foreground/60 text-2xl mt-3 leading-relaxed font-body">{item.a}</p>
          )}
        </button>
      ))}
    </div>
  );
}